enum urls {
  "gettokensubmit" = "https://edgenuity.zendesk.com/access/jwt?return_to=https://help.imaginelearning.com/hc/en-us/sections/5082462459543&jwt=",
  "gettokensubmitforcustomercare" = "https://help.imaginelearning.com/hc/en-us/requests/new",
  "zendesk" = "https://edgenuity.zendesk.com/access/jwt",
  "helpcenter" = "https://help.imaginelearning.com/hc/en-us/sections/5082462459543",
  "customercare" = "https://help.imaginelearning.com/hc/en-us/requests/new"
}

export default urls;
